import * as R from 'ramda'
import { SET_FEATURE_TOGGLES } from 'actions'

export default function featureTogglesReducer(state = {}, action) {
  if (action.type === SET_FEATURE_TOGGLES) {
    return R.mergeDeepRight(state, action.config)
  }
  return state
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/featureToggles.js